import { useContext, useEffect, useState, useMemo, useCallback } from "react";
import { Checkbox, Grid } from "@mantine/core";
import { useLocation, useNavigate } from "react-router-dom";
import { createB2BAPI } from "../../api/Interceptor";
import notify from "../../utils/Notification";
import B2BButton from "../../components/common/B2BButton";
import B2BInput from "../../components/common/B2BInput";
import "./VendorInfo.css"
import { MappedProductContext } from "../../Context/MappedProductContext";

const VendorInfo = ({ vendorId, map }) => {
    const { product, handleChange, setProduct, inputError, setInputError } = useContext(MappedProductContext);
    const [vendors, setVendors] = useState(null);

    const location = useLocation();
    const { venId } = location.state || {};
    const B2B_API = createB2BAPI();
    const navigate = useNavigate();
    useEffect(() => {
        fetchVendors();
    }, []);


    const fetchVendors = async () => {
        try {
            const response = await B2B_API.get(`vendor/${vendorId}`).json();
            const vendorData = response?.response || null;
            setVendors(vendorData);
            if (vendorData) {
                setProduct((prev) => ({
                    ...prev,
                    vendorProductInfo: {
                        ...prev.vendorProductInfo,
                        vendorId: vendorData.vendorId || vendorId,
                        supplier: vendorData.supplier || '',
                    },
                }));
            }
        } catch (error) {
            notify({
                id: 'fetch_vendors',
                error: true,
                success: false,
                title: error?.message || 'Error fetching vendors',
            });
        }
    };

    const saveVendorInfo =useCallback(async () => {
        try {
            if (!product?.productId) {
                notify({
                    id: 'save_vendor',
                    error: true,
                    success: false,
                    title: 'Product ID is required to save vendor information',
                });
                return;
            }

            if (!product?.vendorProductInfo?.vendorProductId || !product?.vendorProductInfo?.grayLeadTime || !product?.vendorProductInfo?.fabricLeadTime || !product?.vendorProductInfo?.costPrice || !product?.vendorProductInfo?.dyeLotLeadTime) {
                notify({
                    id: 'save_vendor',
                    error: true,
                    success: false,
                    title: 'required fields are missing',
                });
                return;
            }

            const vendorPayload = {
                vendorId: product?.vendorProductInfo?.vendorId,
                productId: product?.productId,
                grayLeadTime: product?.vendorProductInfo?.grayLeadTime,
                fabricLeadTime: product?.vendorProductInfo?.fabricLeadTime,
                leadTime: product?.vendorProductInfo?.leadTime,
                costPrice: product?.vendorProductInfo?.costPrice,
                vendorProductId: product?.vendorProductInfo?.vendorProductId,
                vendorProductName: product?.vendorProductInfo?.vendorProductName,
                dyeLotLeadTime: product?.vendorProductInfo?.dyeLotLeadTime,
                supplier: product?.vendorProductInfo?.supplier,
                commission: product?.vendorProductInfo?.commission,
                commissionPercentage: product?.vendorProductInfo?.commissionPercentage,
                sampleAvailable: product?.vendorProductInfo?.sampleAvailable || false,
                swatchAvailable: product?.vendorProductInfo?.swatchAvailable || false,
                swatchSent: product?.vendorProductInfo?.swatchSent || false,
                swatchReceived: product?.vendorProductInfo?.swatchReceived || false,
            };

            const response = await B2B_API.post(`vendorProductInfo/save`, { json: vendorPayload }).json();
            notify({
                id: 'save_vendor',
                title: 'Success!',
                message: 'Product Mapping with Vendor saved successfully',
                error: false,
                success: true,
            });
            navigate(`/VendorProducts`, {
                state: { vendorId: vendorId },
            });
        } catch (error) {
            notify({
                id: 'save_vendor',
                error: true,
                success: false,
                title: error?.message || 'Error saving Mapping with Vendor',
           });
    }
  }, [product]); 

    const formFields = useMemo(() => [
        // {
        //     label: 'Vendor',
        //     value: product?.vendorProductInfo?.supplier || '',
        //     onChange: (event) =>
        //         handleChange(event, 'vendorProductInfo.supplier', 'supplierError'),
        //     type: 'textfield',
        //     fieldType: 'textField',
        //     require: true,
        //     disabled: true,
        //     error: inputError.supplierError,
        // },
        // {
        //     label: 'Vendor ID',
        //     value: product?.vendorProductInfo?.vendorId || '',
        //     onChange: (event) =>
        //         handleChange(event, 'vendorProductInfo.vendorId', 'vendorIdError'),
        //     type: 'text',
        //     fieldType: 'textField',
        //     require: true,
        //     disabled: true,
        //     error: inputError.vendorIdError,
        // },
        {
            label: 'Your Product ID',
            value: product?.vendorProductInfo?.vendorProductId || '',
            onChange: (event) =>
                handleChange(event, 'vendorProductInfo.vendorProductId', 'vendorProductIdError'),
            type: 'text',
            fieldType: 'textField',
            placeholder: 'Enter Vendor Product ID',
            error: inputError.vendorProductIdError,
            disabled: map
        },
        {
            label: 'Your Product Name',
            value: product?.vendorProductInfo?.vendorProductName || '',
            onChange: (event) =>
                handleChange(event, 'vendorProductInfo.vendorProductName', 'vendorProductNameError'),
            type: 'text',
            fieldType: 'textField',
            placeholder: 'Enter Vendor Product Name',
            error: inputError.vendorProductNameError,
            disabled: map
        },
        {
            label: 'Greige Fabric Lead Time',
            value: product?.vendorProductInfo?.grayLeadTime || '',
            onChange: (event) =>
                handleChange(event, 'vendorProductInfo.grayLeadTime', 'grayLeadTimeError'),
            type: 'number',
            fieldType: 'textField',
            require: true,
            placeholder: 'Enter Lead Time',
            error: inputError.leadTimeError,
        },
        {
            label: 'Finished Fabric Lead Time',
            value: product?.vendorProductInfo?.fabricLeadTime || '',
            onChange: (event) =>
                handleChange(event, 'vendorProductInfo.fabricLeadTime', 'fabricLeadTimeError'),
            type: 'number',
            require: true,
            fieldType: 'textField',
            placeholder: 'Enter Lead Time',
            error: inputError.leadTimeError,
        },
        {
            label: 'Dye Lot Lead Time',
            value: product?.vendorProductInfo?.dyeLotLeadTime || '',
            onChange: (event) =>
                handleChange(event, 'vendorProductInfo.dyeLotLeadTime', 'dyeLotLeadTimeError'),
            type: 'number',
            require: true,
            fieldType: 'textField',
            placeholder: 'Enter Lead Time',
            error: inputError.leadTimeError,
        },
        {
            label: 'Cost Price',
            value: product?.vendorProductInfo?.costPrice || '',
            onChange: (event) =>
                handleChange(event, 'vendorProductInfo.costPrice', 'costPriceError'),
            type: 'number',
            fieldType: 'textField',
            placeholder: 'Enter Cost Price',
            require: true,
            error: inputError.costPriceError,
        },
        {
            label: 'Commission',
            value: product?.vendorProductInfo?.commission || '',
            onChange: (event) =>
                handleChange(event, 'vendorProductInfo.commission', 'commissionError'),
            type: 'number',
            fieldType: 'textField',
            placeholder: 'Enter Commission',
            disabled: product?.vendorProductInfo?.commissionPercentage > 0,
            error: inputError.commissionError,
        },
        {
            label: 'Commission Percentage',
            value: product?.vendorProductInfo?.commissionPercentage || '',
            onChange: (event) =>
                handleChange(event, 'vendorProductInfo.commissionPercentage', 'commissionPercentageError'),
            type: 'number',
            fieldType: 'textField',
            placeholder: 'Enter Commission Percentage',
            disabled: product?.vendorProductInfo?.commission > 0,
            error: inputError.commissionPercentageError,
        },
        {
            fieldType: 'checkbox',
            label: 'Sample Available',
            value: product?.vendorProductInfo?.sampleAvailable || false,
            onChange: (event) =>
                handleChange(event, 'vendorProductInfo.sampleAvailable', 'isSampleAvailableError'),
            type: 'checkbox',
            error: inputError.isSampleAvailableError,
        },
        {
            fieldType: 'checkbox',
            label: 'Swatch Available',
            value: product?.vendorProductInfo?.swatchAvailable || false,
            onChange: (event) =>
                handleChange(event, 'vendorProductInfo.swatchAvailable', 'isSwatchAvailableError'),
            type: 'checkbox',
            error: inputError.isSwatchAvailableError,
        }
    ], [product?.vendorProductInfo, inputError, handleChange, map]);

    return (
        <div className="vendorInfo-container" style={{ display: 'flex', flexDirection: 'column', marginTop: '2rem' }} >
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem', marginRight: '2rem' }}>
                    <B2BButton
                        name="Update Info"
                        type="button"
                        onClick={saveVendorInfo}
                        style={{ backgroundColor: '#8BC53F' }}
                    />
                </div>
            </div>

            <form className="form-container-vendor">
                <Grid gutter="xs">
                    {formFields.map((field, index) => (
                        <Grid.Col
                            key={index}
                            span={{ base: 12, sm: 6 }} // base = mobile, sm+ = half
                            style={{ display: "flex" }}
                        >

                            <Grid.Col span={{ base: 4, sm: 3 }}>
                                <label>
                                    {field.label}
                                    {field.require && <span className="error-message"> *</span>}
                                </label>
                            </Grid.Col>
                            <Grid.Col span={{ base: 8, sm: 9 }}>
                                {field.fieldType === 'textField' && (
                                    <B2BInput
                                        value={field.value}
                                        className="input-textField"
                                        onChange={field.onChange}
                                        type={field.type}
                                        placeholder={field.placeholder}
                                        error={field.error}
                                        disabled={field.disabled}
                                    />
                                )}
                                {field.fieldType === 'checkbox' && (
                                    <Checkbox
                                        style={{ display: 'flex', alignItems: 'center' }}
                                        color="#8BC53F"
                                        checked={field.value}
                                        onChange={field.onChange}
                                    />
                                )}
                            </Grid.Col>
                        </Grid.Col>
                    ))}
                </Grid>
            </form>
        </div>
    );
};

export default VendorInfo;